
$(() => {
    // intance via constructor and selector
    let lightbox = new SimpleLightbox({
        elements: '.gallery a.lightbox',
        loadingCaption: 'lädt...',
    });
});

